module.exports = __webpack_public_path__ + "static/img/welcome.ff89e8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcome.png
// module id = 6ozE
// module chunks = 2